module.exports = __webpack_public_path__ + "img/page-09.ccdd96d2.jpg";